import {createSharedPathnamesNavigation} from "next-intl/navigation";
import {locales, localePrefix} from "@/config/locales.config";

export const {Link, usePathname, redirect, useRouter} = createSharedPathnamesNavigation({locales, localePrefix});
